export enum AssessmentRecordUserStatus {
    INVITE_SENT = 'INVITE_SENT',
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED'
}